import { motion } from "framer-motion";
import React from 'react';

const AnimatedSection = () => {

  
  return (
    <div className="w-full">
     <section 
  className="w-full h-fit text-center py-48 flex flex-col items-center"
  style={{
    background: `linear-gradient(to right, pink 0%, white 30%, white 70%, pink 100%), 
                 url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2220%22 height=%2220%22 viewBox=%220 0 20 20%22%3E%3Crect width=%2220%22 height=%2220%22 fill=%22none%22/%3E%3Cg fill=%22%23ffffff%22 fill-opacity=%220.1%22%3E%3Cpath d=%22M0 0h1v1H0zM2 1h1v1H2zM5 3h1v1H5zM1 4h1v1H1zM4 5h1v1H4zM6 8h1v1H6zM9 9h1v1H9zM7 13h1v1H7zM11 12h1v1h-1zM15 0h1v1h-1zM14 5h1v1h-1zM16 9h1v1h-1zM19 13h1v1h-1zM8 17h1v1H8zM19 19h1v1h-1zM0 9h1v1H0zM5 14h1v1H5zM9 16h1v1H9z%22/%3E%3C/g%3E%3C/svg%3E')`,
    backgroundSize: 'cover, 200px 200px',
    backgroundBlendMode: 'multiply',
  }}
>
  <motion.h4 
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1 }}
    className="text-[3.2rem] text-[#ce273d] font-bold font-headingDisplay"
  >
    Threads of Tradition
  </motion.h4>

  <motion.p 
    initial={{ y: -20, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1 }}
    className="text-xl text-[#d4243b] mt-2 font-bodyPhilosopher"
  >
    From the Heart of Odisha to Your Wardrobe,<br/> Celebrating Artistry and Tradition
  </motion.p>

  <div className='w-[900px] mx-40 flex justify-center'>
    <motion.img 
      initial={{ scale: 0.5, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 1 }}
      src='https://utk-24-files.s3.ap-south-1.amazonaws.com/static/Group+1+(1).jpg' 
      className='my-8 rounded-full object-cover h-[400px] w-[600px] border-l-8 border-r-8 border-red-700'
    />
  </div>

  <motion.p 
    initial={{ y: -200, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1 }}
    className='w-[32rem] text-center text-gray-600'
  >
    Step into a world where tradition meets innovation, and every thread
    tells a story. Odisha handloom, renowned for its exquisite
    craftsmanship and rich cultural heritage, beckons you to experience
    the epitome of elegance and grace.
  </motion.p>
</section>


      <section className="w-full h-fit text-center py-32 flex flex-col items-center">
        <motion.h4 
        initial={{opacity: 0 }}
        animate={{opacity: 1 }}
        transition={{ duration: 1 }}
        className="text-[3.2rem] font-bold font-headingDisplay bg-gradient-to-r from-[#ce273d] via-[#e3a82b] to-[#ce273d] text-transparent bg-clip-text">Cotton Classics</motion.h4>
        <motion.p 
        initial={{ y: -20, opacity: 0 }}
        animate={{y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        className="text-xl text-[#d4243b] font-bodyPhilosopher">
         Breathe Easy in Pure Comfort.
        </motion.p>
        {/* <div className='w-[900px] mx-40 flex justify-center'>
        <motion.img 
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{scale: 1, opacity: 1 }}
        transition={{ duration: 1 }}
        src='https://utk-24-files.s3.ap-south-1.amazonaws.com/static/Group+1+(1).jpg' className='my-8 rounded-full object-cover h-[400px] w-[600px] border-l-8 border-r-8  border-red-700'/>
        </div> */}
        <div className='relative w-[600px] h-2 bg-red-700 mt-8'>
          <div className='absolute -right-5 -top-[4px] h-4 w-4 rounded-full bg-yellow-500'></div>
          <div className='absolute -left-5 -top-[4px] h-4 w-4 rounded-full bg-yellow-500'></div>
          <div className='absolute -right-10 -top-[4px] h-4 w-4 rotate-45 bg-yellow-500'></div>
          <div className='absolute -left-10 -top-[4px] h-4 w-4 rotate-45 bg-yellow-500'></div>

        </div>
        <div className='bg-red-800 h-96 w-[600px] mt-1 border-b-[5px] border-yellow-500 rounded-b-2xl'></div>
        <div className='w-[900px] mx-40 flex justify-center'>
        
        </div>
        {/* <motion.p 
        initial={{ y: -200, opacity: 0 }}
        animate={{y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        className='w-[32rem] text-center text-gray-600'>
          Step into a world where tradition meets innovation, and every thread
          tells a story. Odisha handloom, renowned for its exquisite
          craftsmanship and rich cultural heritage, beckons you to experience
          the epitome of elegance and grace.
        </motion.p> */}
      </section>

      <section className="w-full h-fit text-center py-32 flex flex-col items-center">
        <motion.h4 
        initial={{opacity: 0 }}
        animate={{opacity: 1 }}
        transition={{ duration: 1 }}
        className="text-[3.2rem] font-bold font-headingLobster bg-gradient-to-r bg-[#ce273d] text-transparent bg-clip-text">Silken Elegance</motion.h4>
        <motion.p 
        initial={{ y: -20, opacity: 0 }}
        animate={{y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        className="text-xl text-[#d4243b] font-bodyPhilosopher">
         Draped in Divine Luxury, Inspired by Odisha
        </motion.p>
        {/* <div className='w-[900px] mx-40 flex justify-center'>
        <motion.img 
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{scale: 1, opacity: 1 }}
        transition={{ duration: 1 }}
        src='https://utk-24-files.s3.ap-south-1.amazonaws.com/static/Group+1+(1).jpg' className='my-8 rounded-full object-cover h-[400px] w-[600px] border-l-8 border-r-8  border-red-700'/>
        </div> */}
        <div className='relative w-[600px] h-2 bg-red-700 mt-8'>
          <div className='absolute -right-5 -top-[4px] h-4 w-4 rounded-full bg-yellow-500'></div>
          <div className='absolute -left-5 -top-[4px] h-4 w-4 rounded-full bg-yellow-500'></div>
          <div className='absolute -right-10 -top-[4px] h-4 w-4 rotate-45 bg-yellow-500'></div>
          <div className='absolute -left-10 -top-[4px] h-4 w-4 rotate-45 bg-yellow-500'></div>

        </div>
        <div className='bg-red-800 h-96 w-[600px] mt-1 border-b-[5px] border-yellow-500 rounded-b-2xl'></div>
        <div className='w-[900px] mx-40 flex justify-center'>
          
          <div className='bg-red-200 p-1.5 mt-12 rounded-full'>
            <button className='px-4 py-2.5 bg-red-600 rounded-full text-white font-semibold font-bodyPhilosopher'>Discover More Elegance</button>
          </div>
          
        </div>
        {/* <motion.p 
        initial={{ y: -200, opacity: 0 }}
        animate={{y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        className='w-[32rem] text-center text-gray-600'>
          Step into a world where tradition meets innovation, and every thread
          tells a story. Odisha handloom, renowned for its exquisite
          craftsmanship and rich cultural heritage, beckons you to experience
          the epitome of elegance and grace.
        </motion.p> */}
      </section>
    </div>
  );
}

export default AnimatedSection